
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'

export default {
  name: 'MasterAnswer',
  props: {
    commentary: String,
    answers: Array,
    answer: Object,
    images: Array
  },
  components: {
    HeadingLv3
  },
  setup(props: any) {
    const result = props.answer.right_flag ? '正解' : '不正解'
    const rightAnswer = props.answers.find((a: any) => a.right_flag).answer
    return {
      result,
      rightAnswer
    }
  }
}
